"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_KEY_PREFIX = void 0;
exports.AUTH_KEY_PREFIX = 'CognitoIdentityServiceProvider';
